"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M17 9c0-2.76-2.24-5-5-5S7 6.24 7 9c0 2.85 2.92 7.21 5 9.88 2.12-2.69 5-7 5-9.88zm-8 1V8h2V6h2v2h2v2h-2v2h-2v-2H9z",
  opacity: ".3"
}), _react.default.createElement("path", {
  d: "M19 9c0-3.86-3.14-7-7-7S5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13zm-7-5c2.76 0 5 2.24 5 5 0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9c0-2.76 2.24-5 5-5zm1 8v-2h2V8h-2V6h-2v2H9v2h2v2z"
})), 'AddLocationTwoTone');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/AddLocationTwoTone.js
// module id = 1164
// module chunks = 0